<template>
  <div id="news">
    <div class="general-header container">
      <h3 class="cate-title">技术动态</h3>
      <div class="visible-xs" style="clear:both;"></div>
      <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item >技术动态</el-breadcrumb-item>
            </el-breadcrumb>
    </div>
    <div class="news container">
      <ul class="news-list">
        <li class="news-item" v-for="item in serverList" :key="item.id" @click="jumpDetail(item.id)">
          <span class="el-icon-arrow-right"></span>
          {{item.name}}
          <span class="news-data">{{item.data}}</span>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
  import Daily from '../../assets/data/server.js';

  export default {
    name: "server",
    data(){
      return{
        kind:'',
        serverList:[],
      }
    },
    created() {
      this.serverList = Daily.server;
    },

    methods:{
      jumpDetail(id){
        this.$router.push({
          name: 'server-detail',
          params:{
            id:id
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #news{
    .general-header{
      border-bottom: 1px solid #dddddd;
      padding-top: 31px;
      padding-bottom: 31px;
      .cate-title{
        display: inline-block;
        width: 210px;
        margin:0;

      }
      .el-breadcrumb{
        padding: 0 10px;
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .news{
      padding: 20px;
      .news-list{
        height: 500px;
        overflow: auto;
        .news-item{
          margin-bottom: 12px;
          &:hover{
            color:#004ca0;
            cursor: pointer;
          }
          .news-data{
            float: right;
            color: #999999;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/server.vue